import { toLower, groupBy } from 'lodash'

export default class Template {
    constructor(template, locale, code) {
        this.template = template
        this.locale = locale
        this.code = code
    }

    translate(label) {
        try {
            return label.locales[this.locale]
        } catch(err) {
            return false
        }
    }

    components() {

        let components = this.template.components.map(c => {
            return {
                id: c.id,
                qty: "1",
                group: "Component",
                name: this.translate(c.label),
                price: null,
                description: this.translate(c.description) || ''
            }
        })

        if (this.template.upgrade_from_template) {
            const upgradeFromTemplate = new Template(this.template.upgrade_from_template, this.locale)
            return components.concat(upgradeFromTemplate.components())
        }

        return components
    }

    products() {
        let products = [
            {
                id: this.template.product_id,
                qty: "1",
                group: "Template",
                name: this.translate(this.template.label),
                price: this.template.price
            }
        ]

        if (this.template.apps) {
            products = products.concat(this.template.apps.map(i => {
                return {
                    id: i.product_id,
                    qty: i.qty,
                    group: "Apps",
                    name: this.translate(i.label),
                    price: i.price,
                    description: this.translate(i.description) || ''
                }
            }))
        }

        if (this.template.integrations) {
            products = products.concat(this.template.integrations.map(i => {
                return {
                    id: i.product_id,
                    qty: i.qty,
                    name: this.translate(i.label),
                    group: "Integration",
                    price: i.price,
                    pricing_description: this.translate(i.pricing_description) || '',
                    description: this.translate(i.description) || ''
                }
            }))
        }

        let account = this.template.account 
        if (account) {
            products.push({
                id: account.product_id,
                qty: "1",
                group: "Account",
                name: account.name,
                price: account.price
            })
        }

        if (this.template.upgrade_from_template) {
            const upgradeFromTemplate = new Template(this.template.upgrade_from_template, this.locale)
            return products.concat(upgradeFromTemplate.products())
        }

        return products
    }

    groupVisibleProducts() {
        let products = this.products().filter(p => p.group != "Template")
        let grouped = groupBy(products, 'group')

        grouped['Component'] = this.components()

        return grouped
    }

    prepareForCheckoutLink() {
        let body =  {
            products: this.products(),
            short_form: "1",
            trial_period: this.template.trial_period,
            activation_code: this.code
        };

        return body
    }

    priceInCurrency(currency) {
        if (this.template.price === null) {
            return 0
        }
        
        let c = toLower(currency) || "usd"

        return this.products().reduce((prev, next) => {
            return prev + (next.price ? next.price[c] : 0)
        }, 0)
    }
}